export function getOpenJobsTabIndex(isWTA) {
  if (isWTA) {
    return 7;
  } else {
    return 2;
  }
}

export function getWorkTicketHistory(isWTA) {
  if (isWTA) {
    return 3;
  } else {
    return 1;
  }
}

export function getOpenJobsTabIndexFromSession() {
  const isWTA = sessionStorage.getItem("isWTA") === "true";
  return getOpenJobsTabIndex(isWTA);
}

export function getWorkTicketHistoryFromSession() {
  const isWTA = sessionStorage.getItem("isWTA") === "true";
  return getWorkTicketHistory(isWTA);
}
